import React from 'react'
import { getFilteredYear, getUserProfileStyles } from '../../../common/common';

const SearchBar = (props) => {
    const { handleFilterUpdate, handleFilter, filterdata } = props
    const handleSubmit = (event) => {
        event.preventDefault();
        handleFilter();
    };
    return (
        <>
            <div className="col-lg-12">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="filter">
                                <h4>FILTER BY:</h4>
                            </div>
                        </div>

                        <div className="col-lg-4 col-sm-4 form-group state">
                            <select className="form-select" name="class" onChange={(e) => handleFilterUpdate(e.target.name, e.target.value)} value={filterdata.class} aria-label="Default select example">
                                <option value="">Class</option>
                                {getFilteredYear && getFilteredYear().map((year, index) => (
                                    <option key={index} value={year}>Class of {year}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-lg-6 col-sm-6 form-group-class">
                            <select className="form-select" name="style" onChange={(e) => handleFilterUpdate(e.target.name, e.target.value)} value={filterdata.style} aria-label="Default select example">
                                <option value="">Style</option>
                                {Object.keys(getUserProfileStyles).map((key) => (
                                    <option key={key} value={key}>
                                        {getUserProfileStyles[key]}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-lg-2 col-sm-2">
                            <div className="go-btn">
                                <button type="submit" name="btn_submit" className="btn btn-primary" onClick={handleFilter}>GO</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default SearchBar
